var _defs, _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMenuHamburgerInkyPen = function SvgMenuHamburgerInkyPen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Menu_Hamburger_InkyPen_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Menu_Hamburger_InkyPen_svg__cls-1{stroke-width:0}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "Menu_Hamburger_InkyPen_svg__cls-1",
    x: 96,
    y: 144,
    width: 320,
    height: 48,
    rx: 24,
    ry: 24
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "Menu_Hamburger_InkyPen_svg__cls-1",
    x: 96,
    y: 240,
    width: 320,
    height: 48,
    rx: 24,
    ry: 24
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "Menu_Hamburger_InkyPen_svg__cls-1",
    x: 96,
    y: 336,
    width: 320,
    height: 48,
    rx: 24,
    ry: 24
  })));
};
export { SvgMenuHamburgerInkyPen as ReactComponent };
export default "data:image/svg+xml,%3csvg id='Layer_1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3e%3cdefs%3e%3cstyle%3e.cls-1%7bstroke-width:0px;%7d%3c/style%3e%3c/defs%3e%3crect class='cls-1' x='96' y='144' width='320' height='48' rx='24' ry='24'/%3e%3crect class='cls-1' x='96' y='240' width='320' height='48' rx='24' ry='24'/%3e%3crect class='cls-1' x='96' y='336' width='320' height='48' rx='24' ry='24'/%3e%3c/svg%3e";